
import {combineReducers} from 'redux';
import postsReducer from './reducers/postsReducer';


const initialState = {
  name: ""
}
const usersReducer = (state:any, action: {}) => {
  return initialState;
}
const rootReducer = combineReducers({
  users : usersReducer,
  posts: postsReducer
})

export default rootReducer;
